module.exports = __webpack_public_path__ + "img/nr.855c9dc1.svg";